import React from "react";
import { getStyleCss } from "../helper/css_style";

function H2({ blok }) {
  let styles = {};

  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
  }

  return <h2 style={styles}>{blok.body}</h2>;
}

export default H2;
